export enum TimezoneType {
  LOCAL = 'LOCAL',
  UTC = 'UTC',
  SERVER = 'SERVER'
}
